import { Link } from "react-router-dom";
import { BUSINESS } from "../data/business";
import { PaymentBadges } from "./PaymentBadges";

export default function Footer() {
  return (
    <footer className="border-t border-[#39FF14]/10 bg-[#040905]">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <img src="/img/brand/neon-sign.jpeg" alt="SuperTechLED" className="h-10 w-auto mix-blend-screen" />
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#9FB8A8]">
              High-performance LED grow lights designed in Australia for home growers and commercial use. Genuine Samsung diodes,
              Meanwell drivers and friendly local support — bigger harvests, smaller power bills.
            </p>
          </div>
          <div>
            <h4 className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#4ADE80]">Shop</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-[#C9DCD0]">
              <li><Link className="hover:text-[#39FF14]" to="/shop">The full range</Link></li>
              <li><Link className="hover:text-[#39FF14]" to="/product/quantum-sun">Quantum Sun</Link></li>
              <li><Link className="hover:text-[#39FF14]" to="/product/commandship">CommandShip</Link></li>
              <li><Link className="hover:text-[#39FF14]" to="/product/galaxy">Galaxy 750</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#4ADE80]">Good to know</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-[#C9DCD0]">
              <li><Link className="hover:text-[#39FF14]" to="/guides">Grow guides &amp; tech tips</Link></li>
              <li><Link className="hover:text-[#39FF14]" to="/about">About us</Link></li>
              <li><Link className="hover:text-[#39FF14]" to="/faq">FAQ</Link></li>
              <li><Link className="hover:text-[#39FF14]" to="/shipping">Shipping, warranty &amp; returns</Link></li>
              <li><Link className="hover:text-[#39FF14]" to="/contact">Contact us</Link></li>
              <li><Link className="hover:text-[#39FF14]" to="/wholesale">Wholesale &amp; trade</Link></li>
              <li><a className="hover:text-[#39FF14]" href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-[#39FF14]/10 pt-6">
          <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
            <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#4ADE80]/70">
              © 2026 SuperTechLED · Australia
            </p>
            <div className="flex items-center gap-3">
              <span className="font-mono2 text-[9px] uppercase tracking-[0.25em] text-[#4ADE80]/60">We accept</span>
              <PaymentBadges />
            </div>
          </div>
          <p className="mt-4 font-mono2 text-[10px] uppercase tracking-[0.18em] text-[#4ADE80]/50" data-testid="footer-business-details">
            {`${BUSINESS.address}${BUSINESS.abn ? ` · ABN ${BUSINESS.abn}` : ""}${BUSINESS.phone ? ` · ${BUSINESS.phone}` : ""} · ${BUSINESS.email}`}
          </p>
        </div>
      </div>
    </footer>
  );
}
